import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Role } from '../../models/Users/Role';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { identityApiClientWithApi } from '../../utils/http';

export interface RoleState {
  roles: Role[];
  status: Status;
}

const initialState: RoleState = {
  roles: [],
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getRoles = createAsyncThunk(
  'role/getRoles',
  async (_, { rejectWithValue }) => {
    try {
      const response = await identityApiClientWithApi.get<Role[]>('user/role');
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить список ролей!');
    }
  },
);

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRoles.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.roles = action.payload;
        return state;
      })
      .addCase(getRoles.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось получить список ролей';
      });
  },
});

export default roleSlice.reducer;

export const selectRoles = (state: RootState) => state.role.roles;
export const rolesStatus = (state: RootState) => state.role.status;
